import { NavigationDropdown } from "@components/general/NavigationDropdown/NavigationDropdown";
import { OrganizationSwitcher } from "@components/general/NavigationDropdown/OrganizationSwitcher";
import { FC } from "react";
import { Dropdown } from "react-bootstrap";
import { OrganizationViewNavigationDropdownToggle } from "./OrganizationViewNavigationDropdownToggle";

export const OrganizationViewNavigationDropdown: FC = () => (
    <NavigationDropdown toggle={OrganizationViewNavigationDropdownToggle}>
        <OrganizationSwitcher />
        <Dropdown.Divider />
    </NavigationDropdown>
);
